import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actions from "../../redux/actions/orderActions";
import Form from "react-bootstrap/Form";
import "./orders.css";

function OrdersPage() {
  const token = useSelector((state) => state.user.access_token);
  const orders = useSelector((state) => state.orders);
  const [search, setSearch] = useState("");
  const handleShowCreate = () => navigate("/createorder");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getOrders = async () => {
    const response = await axios({
      method: "GET",
      url: process.env.REACT_APP_API_URL + "/api/orders",
      headers: { Authorization: `Bearer ${token}` },
    });

    dispatch(actions.storeOrders(response.data));
  };
  useEffect(() => {
    getOrders();
  }, []);

  const handleStatus = async (order, status) => {
    const response = await axios({
      method: "PUT",
      url: process.env.REACT_APP_API_URL + `/api/orders/${order.id}`,
      headers: { authorization: `Bearer ${token}` },
      data: { status: status },
    });
    dispatch(actions.editOrder(order, status));
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const response = await axios({
      method: "GET",
      url: process.env.REACT_APP_API_URL + `/api/orders?search=${search}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(actions.storeOrders(response.data));
  };

  return (
    <div className="animate__animated animate__fadeIn d-flex flex-column w-100 dashboard-pages">
      <h1 className="h3 ms-3 mb-4">Orders</h1>
      <div className="d-flex justify-content-between mx-3 mb-3">
        <Form
          className="d-flex search-tables"
          onSubmit={(e) => handleSearch(e)}
        >
          <InputGroup>
            <FormControl
              placeholder="Search orders by customer"
              aria-label="Search orders by customer"
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="py-2"
            />
            <Button variant="outline-success" type="submit">
              <i className="bi bi-search"></i>
            </Button>
            <Button
              variant="outline-danger"
              onClick={() => {
                getOrders();
                setSearch("");
              }}
            >
              <i className="bi bi-x-lg"></i>
            </Button>
          </InputGroup>
        </Form>
        {/*         <Button
          variant="success"
          onClick={handleShowCreate}
          className="add-btn fs-5"
        >
          New order
        </Button> */}
      </div>
      <div className="table-container w-100">
        <table className="table table-striped table-hover align-middle border rounded shadow">
          <thead>
            <tr>
              <th className="ps-3">ID</th>
              <th>Customer</th>
              <th>Products</th>
              <th className="shipping-address-col">Shipping Address</th>
              <th className="status-col">Status</th>
              <th>CreatedAt</th>
              <th>View</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orders &&
              orders.map((order) => (
                <tr key={order.id}>
                  <td className="fw-bold ps-3">{order.id}</td>
                  <td>
                    {order.customer.firstname + " " + order.customer.lastname}
                  </td>
                  <td>{order.products.length}</td>
                  <td>{order.shippingAddress}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <Form.Select
                        onChange={(e) => {
                          handleStatus(order, e.target.value);
                        }}
                        className="status-selector"
                        defaultValue={order.status}
                      >
                        <option
                          className="bg-light text-dark"
                          value="On process"
                        >
                          On process
                        </option>
                        <option className="bg-light text-dark" value="Paid">
                          Paid
                        </option>
                        <option
                          className="bg-light text-dark"
                          value="Delivered"
                        >
                          Delivered
                        </option>
                      </Form.Select>
                      <span
                        className={`${
                          order.status === "On process" && "text-danger"
                        } ${order.status === "Paid" && "text-warning"} ${
                          order.status === "Delivered" && "text-success"
                        }  status-dot text-success fs-1 ms-2`}
                      >
                        •
                      </span>
                    </div>
                  </td>

                  <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                  <td>
                    <Button
                      variant="outline-dark"
                      onClick={(e) => {
                        navigate(`/showorder/${order.id}`);
                      }}
                    >
                      <i className="bi bi-eye-fill"></i>
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default OrdersPage;
